if (typeof window.GiftNoteForm === 'undefined') {
  class GiftNoteForm extends HTMLElement {
    constructor() {
      super();

      // Reference to the elements
      this.button = this.querySelector('.gift-note-form__button');
      this.inputs = this.querySelectorAll('input[type="text"]');
      this.charCounters = this.querySelectorAll('.char-counter');

      this.noMessageWarning = this.querySelector('#no-message-warning');

      // Maximum length for each line
      this.maxLength = parseInt(this.getAttribute('maxchar'), 10);

      // Bind event handlers
      this.handleInputChange = this.handleInputChange.bind(this);
      this.addGiftNote = this.addGiftNote.bind(this);
    }

    connectedCallback() {
      // Initialize character counters and attach event listeners
      this.inputs.forEach((input, index) => {
        const value = input.value || '';
        this.updateCharCounter(index, value);

        // Attach event listener for input change
        input.addEventListener('input', this.handleInputChange);
      });

      // Attach event listener to the button
      this.button.addEventListener('click', this.addGiftNote);
    }

    disconnectedCallback() {
      // Remove event listeners
      this.inputs.forEach((input) => {
        input.removeEventListener('input', this.handleInputChange);
      });
      this.button.removeEventListener('click', this.addGiftNote);
    }

    handleInputChange(event) {
      const input = event.target;
      const index = Array.from(this.inputs).indexOf(input);
      const value = input.value;

      // Remove non-ASCII characters (sanitize input)
      const sanitizedValue = value.replace(/[^a-zA-Z0-9 .,?!'-]/g, '');
      if (sanitizedValue !== value) {
        input.value = sanitizedValue;
      }

      // Update character counter
      this.updateCharCounter(index, sanitizedValue);

      // Check if all inputs are empty
      const allEmpty = Array.from(this.inputs).every(input => input.value.trim() === '');

      if (allEmpty) {
        // Display the warning message
        this.noMessageWarning.classList.remove('hidden');
      } else {
        // Hide the warning message
        this.noMessageWarning.classList.add('hidden');
      }
    }

    updateCharCounter(index, value) {
      const remainingChars = value.length;
      const counter = this.charCounters[index];

      counter.querySelector('span').textContent = `${remainingChars}`;

      // Show or hide error message

    }

    addGiftNote(event) {
      event.preventDefault();
      // Collect messages from inputs
      const messages = [];
      let valid = true;

      this.inputs.forEach((input, index) => {
        const value = input.value.trim();
        const remainingChars = this.maxLength - value.length;



        // Add the message to the array if not empty
        if (value) {
          messages.push(value);
        }
      });

      if (!valid) {
        // Do not proceed if any input is invalid
        return;
      }

      let concatenatedMessage = messages.join('\n');

      if (!concatenatedMessage) {
        // No messages entered, set to 'empty card'
        concatenatedMessage = 'empty card';
        // Optionally display the warning message
        this.noMessageWarning.classList.remove('hidden');
      } else {
        // Hide the warning message
        this.noMessageWarning.classList.add('hidden');
      }

      // Prepare data to send
      const attributes = {
        gift_note: true,
        gift_message: concatenatedMessage
      };

      // Send a POST request to update the cart attributes
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: attributes
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart attributes updated:', data);
        // Optionally reload the page or update the UI
        if (window.location.pathname.includes('/cart')) {
          // We are on the cart page, reload the page
          window.location.reload();
        } else {
          window.ShpCustom.Cart.getCart();

          // If you have a mini cart or need to update the cart UI, do it here
        }
      })
      // Add loading state to the button
      this.button.classList.add('loading');
      this.button.disabled = true;


    }
  }

  if (!customElements.get('gift-note-form')) {
    customElements.define('gift-note-form', GiftNoteForm);
  }
}
